export const EventActivityTypes = {
    running: 'running',
    cycling: 'cycling',
    swimming: 'swimming',
    openWaterSwimming: 'open_water_swimming',
    poolSwimming: 'lap_swimming',
    multi_sport: 'multi_sport',
    triathlon: 'multi_sport_triathlon',
    transition: 'transition_v2'
};

export const TriathlonTypes = {
    sprint: 'sprint',
    standard: 'standard',
    half_iron: 'half_iron',
    full_iron: 'full_iron'
};

export const TRIATHLON_SPRINT_DISTANCE_IN_METERS = 25750;
export const TRIATHLON_STANDARD_DISTANCE_IN_METERS = 51500;
export const TRIATHLON_HALF_DISTANCE_IN_METERS = 113120;
export const TRIATHLON_FULL_DISTANCE_IN_METERS = 226340;
